import { mm } from "@inovitas/infra3dsdk";
import React from "react";

export const returnType = (item: string, type: mm.LAYERPROPERTYTYPE) => {
  const dateTimeRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\+\d{2}:\d{2}$/;
  const dateTimeRegex2 = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/;

  if (
    type === mm.LAYERPROPERTYTYPE.NUMBER ||
    type === mm.LAYERPROPERTYTYPE.INTEGER
  ) {
    if (
      item !== null &&
      !isNaN(new Date(item).getTime()) &&
      (dateTimeRegex.test(item) ||
        dateTimeRegex2.test(item) ||
        item.toString().length === 13 ||
        item.toString().length === 14)
    ) {
      return "datetime-local";
    } else {
      return "number";
    }
  } else if (type === mm.LAYERPROPERTYTYPE.STRING) {
    if (
      item !== null &&
      !isNaN(new Date(item).getTime()) &&
      (dateTimeRegex.test(item) ||
        dateTimeRegex2.test(item) ||
        item.toString().length === 13 ||
        item.toString().length === 14)
    ) {
      return "datetime-local";
    } else {
      return "text";
    }
  } else if (type === mm.LAYERPROPERTYTYPE.BOOLEAN) {
    return "checkbox";
  } else if (type === mm.LAYERPROPERTYTYPE.DATE) {
    return "datetime-local";
  } else if (type === mm.LAYERPROPERTYTYPE.ENUM) {
    return "text";
  } else {
    console.error(`Unknown column type ${type}`);
  }
};
